import { createFileRoute } from "@tanstack/react-router";
import { FiscalizationPage } from "@/components/admin/fiscalization/FiscalizationPage";

export const Route = createFileRoute("/dashboard/admin/fiscalization")({
  component: FiscalizationPage,
});
